<template>
    <div>
     <component :is="currentComponent"></component>
    </div>
</template>
<script>
import directPayMainPage from './directPayMainPage.vue';
import accountDetailsHsbc from './hsbcAccount/accountDetailsHsbc.vue';
const mapNameToComponents={
 "directPayMainPage":directPayMainPage,
 "accountDetailsHsbc":accountDetailsHsbc
}
export default{
    data(){
        return{
            sub_step:"directPayMainPage"

        }
    },
    computed:{
    currentComponent: function() {
        return mapNameToComponents[this.sub_step];
    },
    
  },
  
  updated(){
    console.log("route changes")
  }
  
}
</script>
<style>
</style>